import { makeVar, useReactiveVar } from '@apollo/client';

const firstLoadTimeVar = makeVar(new Date().toISOString());
export const httpLogRequestIdVar = makeVar(null); // Initialized during getAppProps

/**
 * Retrieves app stats from Apollo reactive variable
 * https://www.apollographql.com/docs/react/local-state/reactive-variables/
 */
const useAppStats = () => {
  const firstLoadTime = useReactiveVar(firstLoadTimeVar);
  const httpLogRequestId = useReactiveVar(httpLogRequestIdVar);
  const appStats = {
    firstLoadTime,
    httpLogRequestId
  };
  return appStats;
};

export default useAppStats;
